/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_2 from '~icons/ep/arrow-right';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a5d1ae3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "game-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "marginL20"
};
const _hoisted_7 = {
  class: "width400px",
  style: {
    "margin": "0 auto"
  }
};
import { apiAppGameList } from '@/api/app';
import { UseGlobalConfig } from '@/utils/hooks';
import { imgLimit } from '@ultra/share/utils';
import GameForm from './gameForm.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      $has
    } = UseGlobalConfig();
    const currentGame = ref();
    const panes = computed(() => {
      return [{
        title: '游戏列表',
        key: 'gameList'
      }, {
        title: currentGame.value ? '编辑游戏' : '新增游戏',
        key: 'addGame'
      }];
    });
    let active = ref('gameList');
    let gameName = ref('');
    let loading = ref(false);
    let gameList = ref([]);
    const getGameList = async () => {
      loading.value = true;
      const res = await apiAppGameList({
        publish_status: 1,
        status: 1
      });
      if (res.code === 0) {
        gameList.value = res.data;
      }
      loading.value = false;
    };
    const handleClick = (type, item) => {
      if (type === 'edit') {
        if ($has('editGame')) {
          active.value = 'addGame';
          currentGame.value = item;
        }
      } else {
        active.value = 'addGame';
        currentGame.value = null;
      }
    };
    const handleSuccess = () => {
      active.value = 'gameList';
      getGameList();
    };
    onMounted(() => {
      getGameList();
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_i_ep_ArrowRight = __unplugin_components_2;
      const _component_el_icon = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      const _directive_has = _resolveDirective("has");
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_u_card, {
        modelValue: _unref(active),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(active) ? active.value = $event : active = $event),
        panes: _unref(panes),
        fullScreen: ""
      }, {
        extra: _withCtx(() => [_unref(active) !== 'addGame' ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("添加游戏")]),
          _: 1
        })), [[_directive_has, 'addGame']]) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "gameList"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_input, {
            modelValue: _unref(gameName),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(gameName) ? gameName.value = $event : gameName = $event),
            clearable: "",
            class: "width300px marginB20",
            placeholder: "搜索游戏"
          }, null, 8, ["modelValue"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameList).filter(item => item.Name.includes(_unref(gameName))), item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.Id,
              class: "game-item",
              onClick: $event => handleClick('edit', item)
            }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
              src: _unref(imgLimit)(item.Icon, 52)
            }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.Name), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_icon, {
              color: "#606266"
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_ArrowRight)]),
              _: 1
            })])], 8, _hoisted_3);
          }), 128))])), [[_directive_loading, _unref(loading)]])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "addGame"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(GameForm, {
            gameInfo: _unref(currentGame),
            onSuccess: handleSuccess
          }, null, 8, ["gameInfo"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "panes"])]);
    };
  }
});